<div class="ride-assigning-tab">
	<!-- Loading State -->
	<div *ngIf="loading" class="loading-container">
		<mat-spinner diameter="50"></mat-spinner>
		<p class="loading-text">Loading assignment data...</p>
	</div>

	<!-- Content -->
	<div *ngIf="!loading && assigningData" class="assigning-content">
		<!-- Summary Cards -->
		<div class="summary-section">
			<mat-card class="summary-card">
				<mat-card-content>
					<div class="summary-label">Total Attempts</div>
					<div class="summary-value">{{ assigningData.AttemptsCount }}</div>
				</mat-card-content>
			</mat-card>

			<mat-card class="summary-card">
				<mat-card-content>
					<div class="summary-label">Total Time</div>
					<div class="summary-value">{{ assigningData.TotalTimeText }}</div>
				</mat-card-content>
			</mat-card>
		</div>

		<!-- Rounds Accordion -->
		<mat-accordion class="rounds-accordion" multi>
			<!-- First Round -->
			<mat-expansion-panel [expanded]="round1Expanded" (opened)="round1Expanded = true" (closed)="round1Expanded = false">
				<mat-expansion-panel-header>
					<mat-panel-title class="round-title">
						<div class="round-title-left">
							<div class="round-number-icon">1</div>
							<span class="round-name">First Round</span>
						</div>
						<mat-chip class="radius-chip">
							<mat-icon>location_on</mat-icon>
							&lt;{{ assigningData.FirstRadiusToSortRidersInM }}m
						</mat-chip>
					</mat-panel-title>
				</mat-expansion-panel-header>

				<div class="riders-list">
					<div *ngIf="round1Riders.length === 0" class="no-riders">
						<mat-icon>info</mat-icon>
						<span>No riders in this round</span>
					</div>

					<div *ngFor="let rider of round1Riders; let i = index" 
						 class="rider-item" 
						 [ngClass]="getRiderClass(rider, i, AssigningRoundEnum.First)">
						
						<div class="rider-content">
							<img [src]="rider.RiderImageUrl" 
								 alt="{{ rider.RiderName }}" 
								 class="rider-avatar"
								 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.First)">
							
							<div class="rider-info">
								<div class="rider-name" 
									 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.First)">
									{{ rider.RiderName }}
								</div>

								<div class="rider-stats" 
									 *ngIf="!isRiderDisabled(rider, i, AssigningRoundEnum.First)">
									<span class="stat-item">
										<mat-icon class="stat-icon">star</mat-icon>
										{{ rider.RiderRate }}
									</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.DistanceInM }}m</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.CountTrips }} trips</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.AcceptanceRate }}% acceptance</span>
								</div>

								<div class="rider-action-status" 
									 *ngIf="isRiderDisabled(rider, i, AssigningRoundEnum.First)">
									<mat-chip class="status-chip">{{ rider.RiderActionText }}</mat-chip>
								</div>
							</div>
						</div>

						<!-- Progress Bar for Active Rider -->
						<div *ngIf="isRiderActive(rider, i, AssigningRoundEnum.First)" class="progress-section">
							<mat-progress-bar mode="determinate" [value]="(progressValue / 20) * 100" color="primary"></mat-progress-bar>
							<div class="progress-time">{{ progressValue > 0 ? (progressValue | number:'1.0-0') : 0 }}s</div>
						</div>
					</div>
				</div>
			</mat-expansion-panel>

			<!-- Second Round -->
			<mat-expansion-panel [expanded]="round2Expanded" (opened)="round2Expanded = true" (closed)="round2Expanded = false">
				<mat-expansion-panel-header>
					<mat-panel-title class="round-title">
						<div class="round-title-left">
							<div class="round-number-icon">2</div>
							<span class="round-name">Second Round</span>
						</div>
						<mat-chip class="radius-chip">
							<mat-icon>location_on</mat-icon>
							&lt;{{ assigningData.SecondRadiusToSortRidersInM }}m
						</mat-chip>
					</mat-panel-title>
				</mat-expansion-panel-header>

				<div class="riders-list">
					<div *ngIf="round2Riders.length === 0" class="no-riders">
						<mat-icon>info</mat-icon>
						<span>No riders in this round</span>
					</div>

					<div *ngFor="let rider of round2Riders; let i = index" 
						 class="rider-item" 
						 [ngClass]="getRiderClass(rider, i, AssigningRoundEnum.Second)">
						
						<div class="rider-content">
							<img [src]="rider.RiderImageUrl" 
								 alt="{{ rider.RiderName }}" 
								 class="rider-avatar"
								 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.Second)">
							
							<div class="rider-info">
								<div class="rider-name" 
									 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.Second)">
									{{ rider.RiderName }}
								</div>

								<div class="rider-stats" 
									 *ngIf="!isRiderDisabled(rider, i, AssigningRoundEnum.Second)">
									<span class="stat-item">
										<mat-icon class="stat-icon">star</mat-icon>
										{{ rider.RiderRate }}
									</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.DistanceInM }}m</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.CountTrips }} trips</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.AcceptanceRate }}% acceptance</span>
								</div>

								<div class="rider-action-status" 
									 *ngIf="isRiderDisabled(rider, i, AssigningRoundEnum.Second)">
									<mat-chip class="status-chip">{{ rider.RiderActionText }}</mat-chip>
								</div>
							</div>
						</div>

						<!-- Progress Bar for Active Rider -->
						<div *ngIf="isRiderActive(rider, i, AssigningRoundEnum.Second)" class="progress-section">
							<mat-progress-bar mode="determinate" [value]="(progressValue / 20) * 100" color="primary"></mat-progress-bar>
							<div class="progress-time">{{ progressValue > 0 ? (progressValue | number:'1.0-0') : 0 }}s</div>
						</div>
					</div>
				</div>
			</mat-expansion-panel>

			<!-- Third Round -->
			<mat-expansion-panel [expanded]="round3Expanded" (opened)="round3Expanded = true" (closed)="round3Expanded = false">
				<mat-expansion-panel-header>
					<mat-panel-title class="round-title">
						<div class="round-title-left">
							<div class="round-number-icon">3</div>
							<span class="round-name">Third Round</span>
						</div>
						<mat-chip class="radius-chip">
							<mat-icon>location_on</mat-icon>
							&lt;{{ assigningData.ThirdRadiusToSortRidersInM }}m
						</mat-chip>
					</mat-panel-title>
				</mat-expansion-panel-header>

				<div class="riders-list">
					<div *ngIf="round3Riders.length === 0" class="no-riders">
						<mat-icon>info</mat-icon>
						<span>No riders in this round</span>
					</div>

					<div *ngFor="let rider of round3Riders; let i = index" 
						 class="rider-item" 
						 [ngClass]="getRiderClass(rider, i, AssigningRoundEnum.Third)">
						
						<div class="rider-content">
							<img [src]="rider.RiderImageUrl" 
								 alt="{{ rider.RiderName }}" 
								 class="rider-avatar"
								 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.Third)">
							
							<div class="rider-info">
								<div class="rider-name" 
									 [class.disabled]="isRiderDisabled(rider, i, AssigningRoundEnum.Third)">
									{{ rider.RiderName }}
								</div>

								<div class="rider-stats" 
									 *ngIf="!isRiderDisabled(rider, i, AssigningRoundEnum.Third)">
									<span class="stat-item">
										<mat-icon class="stat-icon">star</mat-icon>
										{{ rider.RiderRate }}
									</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.DistanceInM }}m</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.CountTrips }} trips</span>
									<span class="stat-separator">•</span>
									<span class="stat-item">{{ rider.AcceptanceRate }}% acceptance</span>
								</div>

								<div class="rider-action-status" 
									 *ngIf="isRiderDisabled(rider, i, AssigningRoundEnum.Third)">
									<mat-chip class="status-chip">{{ rider.RiderActionText }}</mat-chip>
								</div>
							</div>
						</div>

						<!-- Progress Bar for Active Rider -->
						<div *ngIf="isRiderActive(rider, i, AssigningRoundEnum.Third)" class="progress-section">
							<mat-progress-bar mode="determinate" [value]="(progressValue / 20) * 100" color="primary"></mat-progress-bar>
							<div class="progress-time">{{ progressValue > 0 ? (progressValue | number:'1.0-0') : 0 }}s</div>
						</div>
					</div>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<!-- Empty State -->
	<div *ngIf="!loading && !assigningData" class="empty-state">
		<mat-icon class="empty-icon">assignment</mat-icon>
		<p class="empty-text">No assigning data available</p>
	</div>
</div>
